<div class="header-bar">
    <div class="header-left"></div>
    <div class="header-center">
        {{ newIntegration ? "Create New Integration" : "Integration" }}
    </div>
    <div *ngIf="newIntegration" class="header-right">
        <button mat-button color="fiord" (click)="cancel()">Cancel</button>
        <button mat-button color="lightGreen" (click)="saveNewIntegration()" [disabled]="saveDisabled">
            Save New Integration
        </button>
    </div>
    <div *ngIf="!newIntegration" class="header-right">
        <!--
      <button mat-button color="warn" (click)="deleteIntegration()">
        Delete Integration
      </button>
      -->
        <button mat-button color="lightGreen" (click)="saveIntegrationUpdates()" [disabled]="saveDisabled">
            Save Integration Updates
        </button>
    </div>
</div>
<form class="integration-form" [formGroup]="integrationForm">
    <div class="container-row">
        <lhpe-select controlName="provider" placeholder="Provider" [formGroup]="integrationForm" [required]="true" [options]="providers" optionValue="id" [isOptionDisabled]="getProviderDisabledState.bind(this)">
        </lhpe-select>
        <div *ngIf="providerAlreadyExistsError" class="error-message">
            This provider already has an integration configured for this app.
        </div>
        <div *ngIf="!newIntegration" class="info-message">
            The provider cannot be changed after the integration is created.
        </div>
    </div>
    <div class="container-row" *ngFor="let item of configs; let i = index">
        <lhpe-input
            *ngIf="item.type !== 'textarea' && item.type !== 'json' && item.type !== 'integration_reference' && item.type !== 'secret' && item.type !== 'account_upload_s3' && item.type !== 'color'"
            class="input"
            [controlName]=item.id
            [placeholder]=item.label
            [formGroup]="integrationForm!"
            [required]=item.required
            type=item.type
            [hint]="item.hint"
        >
        </lhpe-input>
        <div *ngIf="item.type === 'color'" class="color-field-row">
            <lhpe-input
                class="input color-text-input"
                [controlName]=item.id
                [placeholder]=item.label
                [formGroup]="integrationForm!"
                [required]=item.required
                type="text"
                [hint]="item.hint"
            >
            </lhpe-input>
            <button
                class="color-picker-btn"
                mat-icon-button
                [(colorPicker)]="colorPickerColor"
                cpOutputFormat="hex"
                cpDialogDisplay="popup"
                [cpUseRootViewContainer]="true"
                cpPosition="auto"
                [cpOKButton]="true"
                cpOKButtonText="Set Color"
                [cpCancelButton]="true"
                (click)="openColorPicker(item.id)"
                (colorPickerSelect)="onColorPickerSelected()"
                cpCancelButtonClass="color-picker-option color-picker-cancel-btn"
                cpOKButtonClass="color-picker-option color-picker-add-btn"
                type="button"
            >
                <span><fa-icon [icon]="faPalette"></fa-icon></span>
            </button>
        </div>
        <lhpe-textarea
            *ngIf="item.type === 'textarea' || item.type === 'json'"
            class="input"
            [controlName]=item.id
            [placeholder]=item.label
            [formGroup]="integrationForm!"
            [required]=item.required
            [rows]="item.rows || 4"
            [maxlength]="item.maxlength"
            [hint]="item.hint"
        >
        </lhpe-textarea>
        <lhpe-select
            *ngIf="item.type === 'integration_reference'"
            [controlName]="item.id"
            [placeholder]="item.label"
            [formGroup]="integrationForm!"
            [required]="item.required"
            [options]="referenceOptions[item.id]"
            optionValue="id"
            displayValue="providerName"
        >
        </lhpe-select>
        <div *ngIf="item.type === 'secret'" class="secret-field" style="display: flex; align-items: center; gap: 8px;">
            <lhpe-input
                [controlName]="item.id"
                [placeholder]="item.label"
                [formGroup]="integrationForm!"
                [required]="item.required"
                type="text"
            >
            </lhpe-input>
            <button mat-button color="primary"
                *ngIf="item.generate"
                (click)="generateSecret(item.id)">
                {{ integrationForm.get(item.id)?.value ? 'Regenerate' : 'Generate' }}
            </button>
        </div>
        <div *ngIf="item.type === 'account_upload_s3'" class="account-upload-field">
            <div class="upload-row">
                <lhpe-input
                    class="upload-url-input"
                    [controlName]="item.id"
                    [placeholder]="item.label"
                    [formGroup]="integrationForm!"
                    [required]="item.required"
                    type="text"
                    [hint]="item.hint"
                >
                </lhpe-input>
                <div class="upload-actions">
                    <input
                        #uploadInput
                        type="file"
                        [accept]="getAcceptForField(item)"
                        (change)="onAccountUploadSelected(item, $event)"
                        style="display: none;"
                    />
                    <button
                        mat-button
                        color="primary"
                        type="button"
                        (click)="uploadInput.click()"
                        [disabled]="uploadingFieldId === item.id"
                    >
                        {{ uploadingFieldId === item.id ? 'Uploading...' : (integrationForm.get(item.id)?.value ? 'Replace file' : 'Upload file') }}
                    </button>
                    <button
                        mat-button
                        color="fiord"
                        type="button"
                        *ngIf="integrationForm.get(item.id)?.value"
                        (click)="copyFieldUrl(item.id)"
                    >
                        Copy URL
                    </button>
                    <button
                        mat-button
                        color="warn"
                        type="button"
                        *ngIf="integrationForm.get(item.id)?.value"
                        (click)="deleteAccountUploadFile(item)"
                        [disabled]="uploadingFieldId === item.id"
                    >
                        Delete file
                    </button>
                </div>
            </div>
            <div *ngIf="uploadErrors[item.id]" class="error-message">
                {{ uploadErrors[item.id] }}
            </div>
        </div>
    </div>
</form>